module.exports = "/_next/static/images/11f9973479b95427ab8dae303c0c0668-months-xs.png.webp";